import * as R from 'ramda'
import {
    FETCH_HISTORY_SUCCESS,
    ADD_HISTORY_SUCCESS
} from '../actionTypes'
import {snapshotToArray} from "../selectors";

const initialState = []

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case(FETCH_HISTORY_SUCCESS):

            return snapshotToArray(payload)
        case(ADD_HISTORY_SUCCESS):
            return [...state, payload]
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/history.js